// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1r7BV","ranges":"BmiRanges_ranges__2E3yD"};